import { EventJournalQueries } from '@entities/eventJournal/model/queries';
import { usePeriodPickerQueries } from '@entities/period-picker/lib/usePeriodPickerQueries';
import { useCalendarQueries } from '@entities/сalendar/lib/useCalendarQueries';
import { useNuqsArrayQueryState, useNuqsQueryState } from '@shared/hooks';

export const useResetFilters = () => {
    const { clearDateRangeQueryValues } = useCalendarQueries();
    const { clearPeriodPickerQueryValue } = usePeriodPickerQueries();
    // const { clearQueryValue: clearSortQueryValue } = useNuqsQueryState(EventJournalQueries.sort);
    const { clearQueryValue: clearSearchQueryValue } = useNuqsQueryState(
        EventJournalQueries.search
    );
    const { clearQueryValue: onClearAuthorsValues } = useNuqsArrayQueryState(
        EventJournalQueries.authors
    );
    const { clearQueryValue: onClearEstimatesValues } = useNuqsArrayQueryState(
        EventJournalQueries.estimate
    );
    const { clearQueryValue: onClearTypesValues } = useNuqsArrayQueryState(
        EventJournalQueries.type
    );

    const onResetFilters = () => {
        void onClearAuthorsValues();
        void onClearEstimatesValues();
        void onClearTypesValues();
        clearDateRangeQueryValues();
        clearPeriodPickerQueryValue();
        // clearSortQueryValue();
        clearSearchQueryValue();
    };

    return {
        onResetFilters,
        clearDateRangeQueryValues,
        clearPeriodPickerQueryValue,
    };
};
